<template>
  <div>
    <v-row no-gutters class="v-cardgrid ml-1">
      <v-col sm="12" class="v-cardgrid-border">
        <v-card class="text-center" outlined tile>
          STOCK
        </v-card>
        <v-row no-gutters>
          <v-col cols="6" sm="6" class="v-cardgrid-border v-cardgrid-top">
            <StockIconDetalle />
          </v-col>
          <v-col cols="6" sm="6" class="v-cardgrid-top">
            <UniVenta />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="6" sm="6" class="v-cardgrid-border v-cardgrid-top">
            <ContenidoMayor />
          </v-col>
          <v-col cols="6" sm="6" class="v-cardgrid-top">
            <DisponibleMayor />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState } from "vuex"
  import { Paleta, Paquete } from "../Icons"
  import StockIconDetalle from "./StockIconDetalle"
  import UniVenta from "./UniVenta"
  import ContenidoMayor from "./ContenidoMayor"
  import DisponibleMayor from "./DisponibleMayor"
  import DisponibleEnTransito from "./DisponibleEnTransito"
  import ContenidoEnTransito from "./ContenidoEnTransito"

  export default {
    computed: {
      ...mapState(["Articulo","Disponible"]),
    },
    components: {
      Paleta,
      Paquete,
      StockIconDetalle,
      UniVenta,
      DisponibleMayor,
      ContenidoMayor,
      ContenidoEnTransito,
      DisponibleEnTransito,
    },
        methods: {
          formatNumber({ num, univenta }) {
            let numeral = require("numeral");
            const formatNum = univenta !== "M2" ? "0,0" : "0,0.00";
            const result = numeral(num).format(formatNum);
            return result;
          },
        },
  }
</script>

<style scoped>
  .v-cardgrid {
    background-color: #ffffff !important;
    border: 1px solid black !important;
    transition: opacity 0.4s ease-in-out;
  }
  .v-cardgrid-border {
    border-right: 1px solid black !important;
  }
  .v-cardgrid-top {
    border-top: 1px solid black !important;
  }
</style>
